import { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';

const Font = Quill.import('attributors/style/font');
const Size = Quill.import('attributors/style/size');
const parchment = Quill.import('parchment');
const BaseImageFormat = Quill.import('formats/image');
const ImageFormatAttributesList = ['alt', 'height', 'width', 'style'];

class ImageFormat extends BaseImageFormat {
  static formats(domNode) {
    return ImageFormatAttributesList.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

Font.whitelist = ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New', 'Roman', 'Verdana'];
Size.whitelist = ['12px', '14px', '16px', '18px', '20px', '22px', '24px'];

Quill.register(Font, true);
Quill.register(Size, true);
Quill.register(ImageFormat, true);
Quill.register('modules/imageResize', ImageResize);

export const modules = {
  toolbar: [
    [{ font: Font.whitelist }],
    [{ size: Size.whitelist }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link', 'image'],
    ['clean'],
    ['undo', 'redo'],
  ],
  imageResize: {
    // https://www.npmjs.com/package/quill-image-resize-module-react 참고
    parchment,
    modules: ['Resize', 'DisplaySize', 'Toolbar'],
  },
  history: {
    delay: 2000,
    maxStack: 500,
    userOnly: true,
  },
};

export const formats = [
  'font',
  'size',
  'header',
  'color',
  'background',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'alt',
  'width',
  'height',
  'style',
  'align',
];
